<p-toast position="top-right"></p-toast>
<div>
	<div class="operation-admin-container container mt-3">
		<fieldset>
			<legend>{{ 'SIGALE_ANGULAR.COMPONENTS.OPERATION_ADMIN.TITRE_SECTION' | translate }}</legend>
			<hr *ngIf="!modeApplicationCohabitation">
			<div>
				<div class="margin-bottom italic">
					{{ 'SIGALE_ANGULAR.COMPONENTS.OPERATION_ADMIN.DESCRIPTION' | translate }}
				</div>
				<div class="margin-bottom dropdown-label">
					<label class="label-width">{{ 'SIGALE_ANGULAR.COMPONENTS.OPERATION_ADMIN.TYPE_OPERATION' | translate }}</label>
					<p-dropdown
							[options]="typesOperationAdminPossibles"
							appendTo="body"
							[disabled]="loading"
							[(ngModel)]="typeOperationAdminSelectionnee"
							(onChange)="onChangeTypeOperationAdmin()">
						<ng-template let-option pTemplate="selectedItem">
							<div>{{ 'SIGALE_ANGULAR.COMPONENTS.OPERATION_ADMIN.TYPE_OPERATION_GENERIQUE.' + option.designation | translate }}</div>
						</ng-template>
						<ng-template let-option pTemplate="item">
							<div>{{ 'SIGALE_ANGULAR.COMPONENTS.OPERATION_ADMIN.TYPE_OPERATION_GENERIQUE.' + option.designation | translate }}</div>
						</ng-template>
					</p-dropdown>
				</div>
				<div class="margin-bottom checkbox-label">
					<label class="label-width">{{ 'SIGALE_ANGULAR.COMPONENTS.OPERATION_ADMIN.INCLURE_ADMIN' | translate }}</label>
					<p-inputSwitch [(ngModel)]="inclureAdmin"/>
				</div>
			</div>
			<legend class="label-width">{{ 'SIGALE_ANGULAR.COMPONENTS.OPERATION_ADMIN.DESCRIPTION_TYPE_OPERATION_GENERIQUE' | translate }}</legend>
			<div>
				<div class="margin-bottom">
					@if (typeOperationAdminSelectionnee) {
						<label class="italic">{{ 'SIGALE_ANGULAR.COMPONENTS.OPERATION_ADMIN.DESCRIPTION_TYPE_OPERATION.' + typeOperationAdminSelectionnee.code | translate }}</label>
					}
				</div>
				@if (typeOperationAdminSelectionnee && typeOperationAdminSelectionnee.parametres.length > 0) {
					<div>
						<form>
							<p-table
									[value]="typeOperationAdminSelectionnee.parametres"
									[loading]="loading"
									loadingIcon="app-spinner"
									sortField="nom"
									[rowHover]="true"
									[scrollable]="true"
									scrollHeight="560px">
								<ng-template pTemplate="header">
									<tr>
										<th class="nom-colonne" pSortableColumn="nom">
											{{ 'SIGALE_ANGULAR.COMPONENTS.OPERATION_ADMIN.TABLEAU.HEADER_NOM' | translate }}
											<p-sortIcon field="nom"></p-sortIcon>
										</th>
										<th class="description-colonne" pSortableColumn="description">
											{{ 'SIGALE_ANGULAR.COMPONENTS.OPERATION_ADMIN.TABLEAU.HEADER_DESCRIPTION' | translate }}
											<p-sortIcon field="description"></p-sortIcon>
										</th>
										<th class="valeurs-possibles-colonne">
											{{ 'SIGALE_ANGULAR.COMPONENTS.OPERATION_ADMIN.TABLEAU.HEADER_VALEURS_POSSIBLES' | translate }}
										</th>
										<th class="valeurs-colonne">{{ 'SIGALE_ANGULAR.COMPONENTS.OPERATION_ADMIN.TABLEAU.HEADER_VALEUR' | translate }}</th>
									</tr>
								</ng-template>
								<ng-template pTemplate="body" let-parametreOperationAdmin>
									<tr [formGroup]="formParParametre.get(parametreOperationAdmin)">
										<td class="left nom-colonne">{{ parametreOperationAdmin.nom }}</td>
										<td class="left description-colonne">
											{{ 'SIGALE_ANGULAR.COMPONENTS.OPERATION_ADMIN.DESCRIPTION_PARAMETRE_OPERATION.' + parametreOperationAdmin.description | translate }}
										</td>
										@if (parametreOperationAdmin.separateurPourValeursMultiples) {
											<td class="left valeurs-possibles-colonne">
												{{ 'SIGALE_ANGULAR.COMPONENTS.OPERATION_ADMIN.TABLEAU.VALEURS_MULTIPLES_POSSIBLES' | translate }}
												'{{ parametreOperationAdmin.separateurPourValeursMultiples }}'
											</td>
										} @else {
											<td class="left valeurs-colonne">
												{{ 'SIGALE_ANGULAR.COMPONENTS.OPERATION_ADMIN.TABLEAU.VALEUR_UNIQUE' | translate }}
											</td>
										}
										<td class="valeurs-colonne">
											@if(parametreOperationAdmin.obligatoire) {
												<span class="required">*</span>
											}
											<textarea
													formControlName="valeur"
													rows="1"
													cols="50"
													pInputTextarea
													[autoResize]="true">
										</textarea>
										</td>
									</tr>
								</ng-template>
								<ng-template pTemplate="emptymessage">
									<tr>
										<td [attr.colspan]="4" class="aucun-parametre">
											{{ 'SIGALE_ANGULAR.COMPONENTS.OPERATION_ADMIN.TABLEAU.AUCUN_PARAMETRE' | translate }}
										</td>
									</tr>
								</ng-template>
							</p-table>
						</form>
					</div>
				}
				<div class="bouton-operation-admin margin-top">
					<button (click)="executerOperationAdmin()"
					        [disabled]="!executionPossible() || loading"
					        [label]="'SIGALE_ANGULAR.COMPONENTS.OPERATION_ADMIN.FOOTER.EXECUTER' | translate"
					        class="ui-button-secondary"
					        icon="fas fa-cog"
					        pButton
					        type="button">
					</button>
				</div>
			</div>
		</fieldset>
	</div>
</div>
<confirmation-modal-component #confirmationModalComponent></confirmation-modal-component>


